import React from 'react';
import { Route, RouteComponentProps } from 'react-router-dom';

import { TextsEdit } from './texts-edit';

function textsEditRoute(routeProps: RouteComponentProps) {
  return (
    <Route
      path={`${routeProps.match.path}/edit/:id`}
      render={() => (
        <>
          <TextsEdit />
        </>
      )}
    />
  );
}

export { textsEditRoute };
